import { Link } from 'react-router-dom';
import Seo from '@/components/feature/Seo';
import Breadcrumbs from '@/components/feature/Breadcrumbs';
import FaqAccordion from '@/components/feature/FaqAccordion';
import { faqs, siteInfo } from '@/mocks/gossip';

export default function FaqPage() {
  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: { '@type': 'Answer', text: item.answer },
    })),
  };

  return (
    <>
      <Seo
        title="常见问题 - 诱惑吃瓜 | 内容来源、更新与订阅说明"
        description="诱惑吃瓜常见问题解答：内容范围、图片质量、更新频率、分类检索、版权更正与订阅方式，一次说清楚。"
        keywords="诱惑吃瓜常见问题,内容来源,更新频率,订阅方式,图片质量"
        type="website"
        jsonLd={structuredData}
      />

      <Breadcrumbs items={[{ label: '首页', path: '/' }, { label: '常见问题' }]} />

      <section className="bg-background-100 py-14 md:py-20">
        <div className="mx-auto max-w-[1240px] px-4 md:px-8">
          <span className="flex items-center gap-2 text-xs font-semibold tracking-[0.24em] text-primary-600">
            <span className="h-3 w-1 rounded-full bg-primary-500" aria-hidden="true" />
            帮助中心
          </span>
          <h1 className="mt-3 font-heading text-3xl font-black text-foreground-950 md:text-5xl">
            常见问题
          </h1>
          <p className="mt-4 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
            关于内容范围、图片来源、更新节奏与订阅方式，我们在这里集中回答。如果下面的内容没能解决你的疑问，欢迎直接联系我们。
          </p>
        </div>
      </section>

      <section className="mx-auto max-w-[1240px] px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="lg:col-span-8">
            <FaqAccordion items={faqs} />
          </div>

          <aside className="lg:col-span-4">
            <div className="flex flex-col gap-6 lg:sticky lg:top-20">
              <div className="rounded-lg border border-background-200 bg-background-100 p-5">
                <h2 className="font-heading text-base font-bold text-foreground-950">仍有疑问？</h2>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                  提交问题后我们会尽快回复。涉及内容更正与版权说明，请尽量附上具体链接。
                </p>
                <Link
                  to="/contact"
                  className="mt-4 flex h-10 items-center justify-center gap-1 whitespace-nowrap rounded-md bg-primary-500 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
                >
                  <i className="ri-customer-service-2-line text-base" aria-hidden="true"></i>
                  联系编辑团队
                </Link>
                <a
                  href={`mailto:${siteInfo.email}`}
                  rel="nofollow"
                  className="mt-2 flex h-10 items-center justify-center gap-1 whitespace-nowrap rounded-md border border-background-300 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-50"
                >
                  <i className="ri-mail-line text-base" aria-hidden="true"></i>
                  {siteInfo.email}
                </a>
              </div>

              <div className="rounded-lg bg-primary-950 p-5 text-background-100">
                <h2 className="font-heading text-base font-bold text-background-50">快速入口</h2>
                <ul className="mt-3 space-y-2 text-sm">
                  <li>
                    <Link to="/category/redcarpet" className="flex items-center gap-2 text-background-200/85 transition-colors hover:text-accent-300">
                      <i className="ri-vip-diamond-line text-base" aria-hidden="true"></i>
                      生图红毯专栏
                    </Link>
                  </li>
                  <li>
                    <Link to="/category/group" className="flex items-center gap-2 text-background-200/85 transition-colors hover:text-accent-300">
                      <i className="ri-group-2-line text-base" aria-hidden="true"></i>
                      高光同框专栏
                    </Link>
                  </li>
                  <li>
                    <Link to="/about" className="flex items-center gap-2 text-background-200/85 transition-colors hover:text-accent-300">
                      <i className="ri-information-line text-base" aria-hidden="true"></i>
                      关于我们
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </aside>
        </div>
      </section>
    </>
  );
}